import { Icons } from "assets/icons";
import FilterBar from "components/common/FilterBar";
import NoDataFound from "components/common/NoDataFound";
import {
  ReferralCodeUsageStatusBadge,
} from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  getReferralHistory,
  resetFilters,
  setFilter,
} from "store/slices/customersSlice";
import { ORDER_BY_OPTIONS, REFERRAL_CODE_USAGE_TYPE } from "utils/constants";
import { getActionFlags } from "utils/getActionFlags";
import { formatUTCDate, getMinMaxDate } from "utils/utils";

const ReferralHistory = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    loading2,
    referralHistory,
    filters: { referralCodeKeyword, dates, status, orderBy, used },
  } = useSelector((state) => state.Customers);
  const { noTransactions } = Icons || {};
  useEffect(() => {
    getAllData();
  }, []);
  const getAllData = (page, action) => {
    const { isReset, isResetKeyword } = getActionFlags(action);

    const payload = {
      perPage: 100,
      pageNo: page || 1,
      orderBy: isReset ? -1 : orderBy,
      senderId: id ?? "",
      used: isReset ? false : used,
      keyword: isResetKeyword ? "" : referralCodeKeyword || "",
      dateRange: isReset ? {} : getMinMaxDate(dates),
    };

    dispatch(getReferralHistory(payload));
  };
  const filtersList = [
    {
      key: "orderBy",
      placeholder: t("Order By"),
      type: "singleSelect",
      options: ORDER_BY_OPTIONS,
    },
    {
      key: "used",
      placeholder: t("Type"),
      type: "singleSelect",
      options: REFERRAL_CODE_USAGE_TYPE,
    },
  ];

  const columns = useMemo(
    () => [
      {
        header: t("Referral Code"),
        key: "gotReferralCode",
      },
      {
        header: t("Receiver"),
        key: "receiver",
        render: (value, item) =>
          value ? (
            <Link to={`/customers/customer-details?id=${item._id}`}>
              {value.phone}
            </Link>
          ) : (
            "-"
          ),
      },
      {
        header: t("Usage Status"),
        key: "used",
        render: (value) => (
          <ReferralCodeUsageStatusBadge status={value} t={t} />
        ),
      },
      {
        header: t("Created Date"),
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
    ],
    [t],
  );
  const handleReset = () => {
    dispatch(resetFilters());
    getAllData(1, { actionType: "RESET" });
  };

  return (
    <div className="p-4">
      <FilterBar
        keyword={referralCodeKeyword}
        setKeyword={(value) => dispatch(setFilter({ key: "referralCodeKeyword", value }))}
        keywordPlaceholder={t("Search by referral Code")}
        filters={filtersList}
        selectedFilters={{ referralCodeKeyword, status, orderBy, used }}
        onFilterUpdate={(key, value) => dispatch(setFilter({ key, value }))}
        onSearch={getAllData}
        onReset={handleReset}
        isDateRange={true}
        dates={dates}
        setDates={(value) => dispatch(setFilter({ key: "dates", value }))}
      />
      {loading2 && <TableShimmer rows={12} columns={8} />}

      {!loading2 && referralHistory?.length === 0 && (
        <NoDataFound title={t("No history found")} icon={noTransactions} />
      )}

      {!loading2 && referralHistory?.length > 0 && (
        <DataTable columns={columns} data={referralHistory} t={t} />
      )}
    </div>
  );
};

export default ReferralHistory;
